module.exports = __webpack_public_path__ + "static/media/CACERVAR_MENU-normal.d5b76260.png";